module.exports = __webpack_public_path__ + "static/img/img1.0f8c49f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/img1.png
// module id = jyIk
// module chunks = 1